"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _hubspot = _interopRequireDefault(require("hubspot"));

var _classnames = _interopRequireDefault(require("classnames"));

var flagsImagePath = (_hubspot.default.bender && _hubspot.default.bender.staticDomainPrefix) + "/ui-addon-i18n/static-1.3462/img/flags.png";

var _default = (0, _createReactClass.default)({
  displayName: "CountryFlag",
  propTypes: {
    countryCode: _propTypes.default.string.isRequired
  },
  getFlagStyle: function getFlagStyle() {
    return {
      backgroundImage: "url(" + flagsImagePath + ")"
    };
  },
  render: function render() {
    var _this$props = this.props,
        countryCode = _this$props.countryCode,
        className = _this$props.className,
        passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["countryCode", "className"]);
    return _react.default.createElement("span", (0, _extends2.default)({}, passThroughProps, {
      className: (0, _classnames.default)('country-flag', className, countryCode.toLowerCase()),
      style: this.getFlagStyle()
    }));
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.3462/js/internal/components/CountryFlag.js
// module id = 449
// module chunks = 5 6